module.exports = __webpack_public_path__ + "img/E2 DP4.116d0426.png";